export class DeviceModulesService{constructor(apiService){this.apiService=void 0;this.basePath='/api/v2/devices';this.apiService=apiService;}/**
   * Fetch modules for a specific device
   * @param deviceId - The unique identifier for the device
   */async getDeviceModules(deviceId){return this.apiService.get(`${this.basePath}/${deviceId}/modules`);}/**
   * Update modules for a specific device
   * @param deviceId - The unique identifier for the device
   * @param modules - The updated modules configuration
   */async updateDeviceModules(deviceId,modules){return this.apiService.put(`${this.basePath}/${deviceId}/modules`,modules);}}